import { Request, Response } from "express"

import { getRatings } from "#services/user/ratings"

export const ratingsList = async (req: Request, res: Response) => {
	const list = await getRatings({ userID: req.params.userID })

	res.json(list)
}
